import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { ObjectSchema } from 'yup'
import { ControllerRenderProps } from 'react-hook-form/dist/types/controller'

export interface AugmentedControllerRenderProps extends ControllerRenderProps {
    disabled: boolean
    label: string
    error: boolean
    helperText: string
}

export const useStepForm = (
    componentName: string,
    schema: ObjectSchema<any>,
    values: Record<string, any>,
    disabled: boolean
) => {
    const { t } = useTranslation()
    const form = useForm(
        {
            mode: 'onSubmit',
            reValidateMode: 'onChange',
            resolver: yupResolver(schema),
            defaultValues: values
        }
    )
    const continueDisabled = disabled || (form.formState.isDirty && !form.formState.isValid)

    return {
        ...form,
        continueDisabled: continueDisabled,
        augmentedFieldProps: (field: ControllerRenderProps<any, any>): AugmentedControllerRenderProps => {
            return {
                ...field,
                disabled: disabled,
                label: t(`${componentName}.${field.name}.label`),
                error: !!form.formState.errors?.hasOwnProperty(field.name),
                helperText: !!form.formState.errors?.hasOwnProperty(field.name)
                    ? t(`${componentName}.${field.name}.error`)
                    : t(`${componentName}.${field.name}.helperText`)
            }
        }
    }
}
